function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IllustrationError = function IllustrationError(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "263",
    height: "208",
    viewBox: "0 0 263 208",
    fill: "none",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("g", {
    opacity: "0.5"
  }, ___EmotionJSX("path", {
    opacity: "0.2",
    d: "M0.367152 157.244C0.367152 179.57 16.7472 202.655 39.5679 206.271C45.08 207.144 50.8356 207.039 57.4746 206.507C78.3234 204.849 107.936 199.007 166.515 206.073C236.719 214.536 227.527 183.934 222.801 151.931C222.453 149.633 222.144 147.324 221.88 145.019C221.765 144.014 221.664 143.016 221.57 142.014L221.497 141.208C220.948 134.688 220.979 128.287 222.307 122.327C226.199 104.876 263.122 60.1258 227.044 36.2382C211.033 25.6296 194.771 29.3258 180.238 34.6805C179.092 35.1047 177.959 35.5335 176.836 35.967C167.794 39.4928 159.521 43.2689 152.52 44.1103C151.644 44.2111 150.781 44.2807 149.926 44.3155C120.442 45.6089 103.276 8.72753 74.9048 19.6977C45.6921 30.9843 54.755 79.959 49.7436 95.8215C44.9479 111.016 7.28779 112.251 1.2018 147.164C0.633119 150.494 0.353859 153.866 0.367152 157.244Z",
    fill: "#64C9C3"
  })), ___EmotionJSX("path", {
    d: "M119.015 106.263C117.384 107.02 115.94 108.13 114.79 109.512C113.639 110.895 112.81 112.516 112.363 114.259L97.8117 82.9982C97.7311 82.8244 97.6171 82.6682 97.476 82.5386C97.335 82.409 97.1697 82.3084 96.9898 82.2427C96.8099 82.177 96.6187 82.1475 96.4273 82.1558C96.2359 82.164 96.0481 82.21 95.8745 82.2909L66.7356 95.852C66.5579 95.9325 66.4072 96.0625 66.3014 96.2265C66.1957 96.3905 66.1395 96.5815 66.1395 96.7766C66.1395 96.9717 66.1957 97.1627 66.3014 97.3267C66.4072 97.4907 66.5579 97.6207 66.7356 97.7013C69.333 98.8905 71.4268 100.959 72.6473 103.542C75.4746 109.511 72.9671 116.739 67.0453 119.668C64.9409 120.71 62.58 121.121 60.2474 120.851C57.9147 120.582 55.7098 119.643 53.8985 118.149C52.0872 116.654 50.7469 114.668 50.039 112.429C49.3312 110.19 49.2861 107.794 49.9091 105.53C49.9605 105.342 49.9569 105.144 49.8988 104.958C49.8406 104.773 49.7304 104.608 49.5813 104.483C49.4321 104.358 49.2502 104.279 49.0573 104.255C48.8644 104.23 48.6685 104.262 48.493 104.346L19.2222 117.967C18.8715 118.131 18.6 118.426 18.4674 118.79C18.3347 119.153 18.3518 119.554 18.5149 119.905L52.0241 191.947C52.7617 193.521 54.0924 194.739 55.7255 195.335C57.3585 195.931 59.1611 195.856 60.7393 195.127L132.784 161.606C132.958 161.526 133.114 161.412 133.244 161.271C133.374 161.13 133.474 160.965 133.54 160.785C133.605 160.606 133.635 160.415 133.627 160.223C133.619 160.032 133.573 159.844 133.492 159.671L118.885 128.278C120.737 129.169 122.784 129.578 124.835 129.465C126.887 129.352 128.877 128.723 130.62 127.634C132.363 126.546 133.802 125.035 134.804 123.241C135.806 121.446 136.338 119.428 136.35 117.373C136.362 115.319 135.854 113.294 134.874 111.488C133.893 109.682 132.472 108.154 130.742 107.045C129.012 105.936 127.029 105.283 124.979 105.146C122.929 105.009 120.877 105.393 119.015 106.263Z",
    fill: "url(#paint0_linear_204_76)"
  }), ___EmotionJSX("path", {
    d: "M112.924 109.308C111.292 110.065 109.849 111.175 108.699 112.558C107.548 113.941 106.719 115.562 106.272 117.304L91.7207 86.0437C91.6401 85.8699 91.526 85.7137 91.385 85.5841C91.244 85.4545 91.0787 85.3539 90.8988 85.2882C90.7188 85.2226 90.5277 85.193 90.3363 85.2013C90.1449 85.2095 89.9571 85.2555 89.7835 85.3365L60.6446 98.8975C60.4669 98.978 60.3162 99.108 60.2104 99.272C60.1047 99.436 60.0485 99.627 60.0485 99.8221C60.0485 100.017 60.1047 100.208 60.2104 100.372C60.3162 100.536 60.4669 100.666 60.6446 100.747C63.242 101.936 65.3358 104.005 66.5563 106.587C69.3836 112.557 66.8761 119.785 60.9542 122.713C58.8498 123.755 56.489 124.166 54.1563 123.897C51.8237 123.627 49.6188 122.688 47.8075 121.194C45.9962 119.7 44.6559 117.713 43.948 115.474C43.2402 113.235 43.195 110.839 43.8181 108.575C43.8695 108.388 43.8659 108.19 43.8077 108.004C43.7496 107.818 43.6394 107.653 43.4903 107.529C43.3411 107.404 43.1592 107.325 42.9663 107.3C42.7734 107.276 42.5775 107.307 42.4019 107.391L13.1311 121.013C12.7805 121.176 12.509 121.472 12.3764 121.835C12.2437 122.199 12.2608 122.6 12.4239 122.95L45.9331 194.992C46.6707 196.566 48.0014 197.784 49.6345 198.38C51.2675 198.976 53.0701 198.902 54.6483 198.173L126.693 164.652C126.867 164.571 127.023 164.458 127.153 164.317C127.283 164.176 127.383 164.011 127.449 163.831C127.514 163.651 127.544 163.46 127.536 163.269C127.528 163.078 127.482 162.89 127.401 162.716L112.794 131.324C114.646 132.215 116.692 132.623 118.744 132.511C120.796 132.398 122.786 131.768 124.529 130.68C126.272 129.592 127.711 128.08 128.713 126.286C129.715 124.492 130.247 122.474 130.259 120.419C130.271 118.364 129.763 116.34 128.783 114.534C127.802 112.728 126.381 111.2 124.651 110.091C122.921 108.982 120.938 108.329 118.888 108.192C116.838 108.055 114.786 108.439 112.924 109.308Z",
    fill: "url(#paint1_linear_204_76)"
  }), ___EmotionJSX("path", {
    d: "M211.306 59.9605C210.84 61.6973 210.765 63.516 211.087 65.2853C211.409 67.0547 212.119 68.7304 213.168 70.1918L179.855 61.3073C179.67 61.258 179.477 61.2456 179.287 61.2708C179.097 61.2961 178.914 61.3585 178.748 61.4545C178.582 61.5505 178.437 61.6782 178.321 61.8303C178.204 61.9824 178.119 62.156 178.07 62.3411L180.1 85.4481C180.048 85.6359 180.052 85.8345 180.11 86.0204C180.168 86.2062 180.279 86.3714 180.428 86.4962C180.578 86.6211 180.76 86.7003 180.953 86.7245C181.146 86.7486 181.342 86.7167 181.518 86.6325C184.096 85.4036 187.025 85.1244 189.788 85.844C196.182 87.5021 189.8 107.259 188.248 113.68C186.638 120.348 190.018 124.339 183.428 122.59C180.638 121.851 178.204 120.14 176.564 117.764C176.453 117.604 176.299 117.479 176.119 117.404C175.939 117.329 175.742 117.308 175.55 117.342C175.358 117.376 175.18 117.465 175.038 117.597C174.895 117.73 174.793 117.901 174.745 118.089L156.27 144.046C156.171 144.419 156.224 144.817 156.418 145.152C156.612 145.487 156.931 145.731 157.304 145.831L234.082 166.303C235.763 166.746 237.551 166.506 239.055 165.635C240.56 164.765 241.659 163.334 242.112 161.655L262.584 84.8779C262.684 84.5041 262.631 84.1063 262.437 83.7716C262.243 83.437 261.924 83.1929 261.551 83.0929L228.097 74.1695C229.969 73.3201 231.595 72.011 232.824 70.3642C234.053 68.7174 234.846 66.7864 235.128 64.7508C235.411 62.7153 235.174 60.6413 234.439 58.7221C233.704 56.8028 232.496 55.1006 230.927 53.7738C229.357 52.4471 227.478 51.5389 225.463 51.1338C223.448 50.7287 221.364 50.8399 219.404 51.457C217.444 52.0741 215.671 53.1771 214.252 54.6633C212.833 56.1495 211.812 57.9706 211.286 59.9571L211.306 59.9605Z",
    fill: "url(#paint2_linear_204_76)"
  }), ___EmotionJSX("path", {
    d: "M205.046 58.2686C204.58 60.0054 204.505 61.8241 204.827 63.5934C205.149 65.3627 205.859 67.0385 206.907 68.4998L173.594 59.6154C173.409 59.566 173.216 59.5536 173.026 59.5789C172.837 59.6041 172.654 59.6665 172.488 59.7625C172.322 59.8585 172.177 59.9862 172.06 60.1383C171.944 60.2905 171.859 60.4641 171.809 60.6491L163.519 91.7084C163.467 91.8961 163.471 92.0948 163.529 92.2806C163.587 92.4665 163.697 92.6316 163.847 92.7565C163.996 92.8813 164.179 92.9605 164.372 92.9847C164.565 93.0089 164.761 92.9769 164.937 92.8927C167.514 91.6639 170.443 91.3847 173.207 92.1043C179.601 93.7624 183.54 100.322 181.988 106.743C181.438 109.026 180.24 111.101 178.537 112.718C176.835 114.335 174.701 115.425 172.393 115.857C170.085 116.288 167.701 116.043 165.529 115.151C163.357 114.259 161.49 112.757 160.152 110.827C160.041 110.667 159.887 110.542 159.707 110.467C159.527 110.392 159.33 110.371 159.138 110.405C158.946 110.439 158.768 110.528 158.626 110.66C158.483 110.793 158.381 110.964 158.333 111.152L150.01 142.354C149.911 142.727 149.964 143.125 150.158 143.46C150.352 143.795 150.67 144.039 151.044 144.139L227.822 164.611C229.503 165.054 231.291 164.814 232.795 163.944C234.3 163.073 235.399 161.642 235.852 159.963L256.324 83.186C256.423 82.8122 256.37 82.4143 256.176 82.0797C255.983 81.745 255.664 81.501 255.29 81.401L221.837 72.4776C223.708 71.6281 225.334 70.3191 226.564 68.6723C227.793 67.0255 228.586 65.0945 228.868 63.0589C229.151 61.0233 228.913 58.9494 228.179 57.0301C227.444 55.1109 226.236 53.4087 224.667 52.0819C223.097 50.7551 221.218 49.8469 219.203 49.4419C217.188 49.0368 215.104 49.148 213.144 49.7651C211.183 50.3822 209.411 51.4852 207.992 52.9714C206.572 54.4576 205.552 56.2787 205.026 58.2652L205.046 58.2686Z",
    fill: "url(#paint3_linear_204_76)"
  }), ___EmotionJSX("path", {
    d: "M172.359 33.27L184.064 12.9953",
    stroke: "url(#paint4_linear_204_76)",
    strokeWidth: "6.47382",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M137.788 26.9099V3.5",
    stroke: "url(#paint5_linear_204_76)",
    strokeWidth: "6.47382",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M105.561 32.8605L89.0052 16.3064",
    stroke: "url(#paint6_linear_204_76)",
    strokeWidth: "6.47382",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "paint0_linear_204_76",
    x1: "20.0098",
    y1: "142.933",
    x2: "137.574",
    y2: "134.754",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F3A8B7"
  }), ___EmotionJSX("stop", {
    offset: "0.57",
    stopColor: "#F08E9F"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EE7F91"
  })), ___EmotionJSX("linearGradient", {
    id: "paint1_linear_204_76",
    x1: "13.9192",
    y1: "145.979",
    x2: "131.483",
    y2: "137.799",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F8CFD7"
  }), ___EmotionJSX("stop", {
    offset: "0.2",
    stopColor: "#F7C5CE"
  }), ___EmotionJSX("stop", {
    offset: "0.53",
    stopColor: "#F6BCC6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F6B9C3"
  })), ___EmotionJSX("linearGradient", {
    id: "paint2_linear_204_76",
    x1: "156.237",
    y1: "108.726",
    x2: "262.654",
    y2: "108.726",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#69C1BE"
  }), ___EmotionJSX("stop", {
    offset: "0.29",
    stopColor: "#63C0BB"
  }), ___EmotionJSX("stop", {
    offset: "0.66",
    stopColor: "#53BBB4"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#3EB6AB"
  })), ___EmotionJSX("linearGradient", {
    id: "paint3_linear_204_76",
    x1: "149.976",
    y1: "107.034",
    x2: "256.394",
    y2: "107.034",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#7CDCCC"
  }), ___EmotionJSX("stop", {
    offset: "0.41",
    stopColor: "#76D8CA"
  }), ___EmotionJSX("stop", {
    offset: "0.94",
    stopColor: "#66CBC4"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#64C9C3"
  })), ___EmotionJSX("linearGradient", {
    id: "paint4_linear_204_76",
    x1: "12390.3",
    y1: "7755.09",
    x2: "13633.2",
    y2: "7755.09",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#4EB2C9"
  }), ___EmotionJSX("stop", {
    offset: "0.56",
    stopColor: "#3CA6BF"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2A9AB6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint5_linear_204_76",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#4EB2C9"
  }), ___EmotionJSX("stop", {
    offset: "0.56",
    stopColor: "#3CA6BF"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2A9AB6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint6_linear_204_76",
    x1: "9214.22",
    y1: "6479.52",
    x2: "11446.8",
    y2: "6479.52",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#4EB2C9"
  }), ___EmotionJSX("stop", {
    offset: "0.56",
    stopColor: "#3CA6BF"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2A9AB6"
  }))));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IllustrationError));
//# sourceMappingURL=IllustrationError.js.map